<template>
    <div class="body">
      <div class="header">
        <el-form :model="MiniFindDTO" :inline="true">
          <el-form-item label="上传日期">
            <el-date-picker
              size="small"
              v-model="date"
              type="daterange"
              :picker-options="cellClassName"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              @change="chooeDate"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="文件名称">
            <el-input
              size="small"
              v-model="MiniFindDTO.fileName"
              placeholder="文件名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="serchInfo">
              搜索
            </el-button>

            <el-button @click="submit" size="small" type="primary">下载</el-button>
            <el-button size="small" type="primary" @click="handleBathOrderProduction">下单制作</el-button>
            <el-button size="small" type="danger" @click="handleDelete">删除</el-button>
            <el-button size="small" type="danger" @click="handleBathDelete">删除制作</el-button>

            <br>

          </el-form-item>

        </el-form>
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="新增产品"
        :visible.sync="drawer"
        width="500px"
      >
        <el-form
          ref="productAccountForm"
          :rules="rules"
          :model="productAccountForm"
          label-width="120px"
          class="demo-accountForm"
        >

        <el-form-item style="margin-top: 5px" label="产品名称" prop="category">
          <el-select clearable size="small" v-model="productAccountForm.category" allow-create filterable @change="getCategory()">
            <el-option
              v-for="item in category"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top: 5px" label="产品类别" prop="remark">
        <el-select clearable size="small" v-model="productAccountForm.subclass"  filterable allow-create  @change="getProductInfo()">
          <el-option
            v-for="item in subclass"
            clearable
            :key="item.subclass"
          :label="item.subclass"
          :value="item.subclass"
          />
        </el-select>
      </el-form-item>
      <el-form-item style="margin-top: 5px" label="规格" prop="specifications">
        <el-select clearable size="small" v-model="productAccountForm.specifications"  filterable allow-create  @change="getSpecifications()">
          <el-option
            v-for="item in specifications"
            clearable
            :key="item.specifications"
          :label="item.specifications"
          :value="item.specifications"
          />
        </el-select>
      </el-form-item>

          <el-form-item  label="单价" prop="listPrice">
          <el-input
            class="input-remark"
            size="small"
            v-model="productAccountForm.listPrice"
            placeholder="请输入单价"
          ></el-input>
        </el-form-item>
        <el-form-item  label="单位" prop="unit">
          <el-input
            class="input-remark"
            size="small"
            v-model="productAccountForm.unit"
            placeholder="请输入单位"
          ></el-input>
        </el-form-item>

        <el-form-item  label="物料清单" prop="boringList">
          <el-input
            class="input-remark"
            size="small"
            v-model="productAccountForm.boringList"
            placeholder="请输入物料清单"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 20px" label="产品性质" prop="remark">
        <el-select clearable size="small" v-model="productAccountForm.nature">
          <el-option
            v-for="item in nature"
            clearable
            :key="item.value"
          :label="item.label"
          :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="上传底板文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/miniUpload/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="miniPathSuccess"
                        >
                        <img v-if="productAccountForm.floorPath" :src="productAccountForm.floorPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
        </el-form-item>
            <el-form-item label="上传面板文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/miniUpload/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="miniPanelPathPathSuccess"
                        >
                        <img v-if="productAccountForm.panelPath" :src="productAccountForm.panelPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传字稿文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/imposition/upload"
                        name="files"
                        :show-file-list="false"
                        :on-success="impositionPathSuccess"
                        >
                        <img v-if="productAccountForm.impositionPath" :src="productAccountForm.impositionPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="上传存档文件"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/keep/miniUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="keepPathSuccess"
                        >
                        <img v-if="productAccountForm.keepPath" :src="productAccountForm.keepPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                         <el-form-item label="上传缩略图"  class="errorPageImg">
                       <el-upload
                        class="avatar-uploader"
                        action="api/serviceCenter/orderInfo/orderThumbnailUpload"
                        name="files"
                        :show-file-list="false"
                        :on-success="thumbnailPathSuccess"
                        :before-upload="beforeAvatarUpload"
                        >
                        <img v-if="productAccountForm.thumbnailPath" :src="productAccountForm.thumbnailPath"  style="max-height: 100px;max-width: 100px cursor:pointer" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
            <el-button
              size="small"
              type="primary"
              @click="submitForm('productAccountForm')"
            >
              立即创建
            </el-button>

        </el-form>
      </el-dialog>
        <div style="display: flex">
          <!-- <el-button size="small" type="primary">导入</el-button> -->
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
        </div>
  </div>
  <div class="pagination">
  <el-pagination
          :current-page="currentPage"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
        </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
        <el-table-column
            prop="createTime"
            align="center"
            label="上传时间"
            width="250"
          ></el-table-column>
          <el-table-column
      prop="thumbnail"
      label="缩略图"
      align="center"
      width="400" >
   <template slot-scope="scope">
   <el-popover placement="top-start" trigger="click">
   <!--trigger属性值：hover、click、focus 和 manual-->
   <a :href="scope.row.thumbnail"  target="_blank" title="查看最大化图片">
   <img :src="scope.row.thumbnail" style="max-height: 800px;max-width: 800px">
    </a>
    <img slot="reference" :src="scope.row.thumbnail" style="max-height: 50px;max-width: 50px cursor:pointer">
    </el-popover>
   </template>
  </el-table-column>
          <el-table-column
            prop="fileName"
            align="center"
            label="文件名"
          ></el-table-column>
          <el-table-column
            prop="productType"
            align="center"
            label="功能名称"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="customerName"
            align="center"
            label="客户名称"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="operator"
            align="center"
            label="操作人"
            width="100"
          ></el-table-column>
          <el-table-column
          prop="number"
          align="center"
          label="数量"
        ></el-table-column>
          <el-table-column
            prop="remarks"
            align="center"
            label="备注信息"
            width="200"

          ></el-table-column>
          <el-table-column label="操作" align="center" >
            <template v-slot="{ row }">
              <el-link type="success" size="small" @click="handleEdit(row)">备注</el-link>|
              <el-link type="success" size="small" @click="tohandleEdit(row)">添加到产品</el-link>
            </template>

          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">

     
      </div>
      <el-dialog title="备注" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
          <el-form
            ref="accountForm"
            :model="accountForm"
            label-width="100px"
            class="demo-accountForm"
          >
            <el-form-item label="备注信息" prop="panelMaterial">
              <el-input v-model="accountForm.remarks" type="textarea"></el-input>
            </el-form-item>

          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible = false">取 消</el-button>
            <el-button size="small" type="primary" @click="editAccount()">
              确 定
            </el-button>
          </span>
        </el-dialog>
    </div>


  </template>

  <script>
  import {keepSelectInfo,keepBatchDelete,batchDelete,orderProduction,keepRemake,selectProductCategory,addToProduct,addProduct,productSelectInfo,selectProduct,productSelectInfoWeb} from '@/api/archiving'
  export default {
    data() {
      return {
        specifications:[],
        productAccountForm: {
            name:'',
            category:'',
            subclass:'',
            number:'',
            unit:'',
            specifications:'',
            listPrice:'',
            lowestSellingPrice:'',
            boringList:'',
            nature: '',
            id:'',
            access:'',
            floorPath:'',
            panelPath:'',
            impositionPath:'',
            thumbnailPath:'',
            keepPath:''
          },
          category:[],
          subclass:[],
        nature: [{
          value: '0',
          label: '常规产品'
        }, {
          value: '1',
          label: '标准件'
        }],
        rules:{
                    category:[
                    { required: true, message: '请输入产品分类:大类', trigger: 'blur' }],
                    subclass:[
                    { required: true, message: '请输入产品分类:小类', trigger: 'blur' }],

            },
        isLock: false,
        dialogVisible: false,
        drawer: false,
        pageSize: 10,
        param:'1800',
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        compositionStatus:[{
          value: '0',
          label: '未拼版'
        }, {
          value: '1',
          label: '已拼版'
        }],
        downloadStatus: [{
          value: '0',
          label: '未下载'
        }, {
          value: '1',
          label: '已下载'
        },{
        value: '2',
        label: '待确定'
      }],
        cellClassName: {
          shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2)
              picker.$emit('pick', [start, end])
            }
          },
            {
              text: '最近一周',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近一个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
                picker.$emit('pick', [start, end])
              }
            },
            {
              text: '最近三个月',
              onClick(picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89)
                picker.$emit('pick', [start, end])
              }
            }
          ]

        },
        date: '',
        conTract: [],
        buttonInfo:[],
        MiniFindDTO:{
          operator:'',
          fileName:'',
          materialType:'',
            startTime: '',
            endTime: '',
            access: '',
            productType: '',
            fileType:'存档文件',
            downloadStatus:'',
            compositionStatus:''
        },
        accountForm:{
          id:'',
          access:'',
          operator:'',
          productType:'',
          fileName:'',
          fileType:'',
          materialType:'',
          correspondingTable:'',
          thumbnail:'',
          number:'',
          path:'',
          downloadStatus:'',
          nc:'',
          remarks:'',
          customerName:''
        },
        ProductFindDTO:{
          fileName:'',
          materialType:'',
            startTime: '',
            endTime: '',
            access: '',
            name:'',
            number:'',
            category:'',
            subclass:'',
            nature:'',
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          remarks:'',
          values: ''
        },
        DeleteDTO:{
          id:'',
          status:''
        }
      }
    },
    beforeMount(){

    },

    mounted() {
      this.MiniFindDTO.access=localStorage.getItem("access")
      this.getTableData()
      this.getProductCategory()

    },


    methods: {
      getCategory(){
        this.ProductFindDTO.category=this.productAccountForm.category
        this.ProductFindDTO.access=localStorage.getItem("access")
        productSelectInfoWeb(this.currentPage, 10000, this.ProductFindDTO).then((res) => {
          this.subclass = res.data.data.records
         // this.total = Number(res.data.data.total)
        })
      },
      getProductInfo(){
        this.ProductFindDTO.subclass=this.productAccountForm.subclass
        productSelectInfoWeb(this.currentPage, 10000, this.ProductFindDTO).then((res) => {
          this.specifications = res.data.data.records
         // this.total = Number(res.data.data.total)
        })
        // selectProduct(this.productAccountForm.id).then((res) => {

        // this.productAccountForm.id=res.data.data.id
        // this.productAccountForm.subclass=res.data.data.subclass
        //  this.productAccountForm.listPrice=res.data.data.listPrice
        //  this.productAccountForm.unit=res.data.data.unit
        //  this.productAccountForm.boringList=res.data.data.boringList
        //  this.productAccountForm.nature=res.data.data.nature
        //  this.productAccountForm.specifications=res.data.data.specifications
        // })
      },


      getSpecifications(){
        this.ProductFindDTO.getSpecifications=this.productAccountForm.getSpecifications
        productSelectInfoWeb(this.currentPage, 10000, this.ProductFindDTO).then((res) => {
          this.productAccountForm.listPrice = res.data.data.records[0].listPrice
          this.productAccountForm.unit = res.data.data.records[0].unit
          this.productAccountForm.id = res.data.data.records[0].id
          this.productAccountForm.boringList = res.data.data.records[0].boringList
          this.productAccountForm.nature = res.data.data.records[0].nature
          this.productAccountForm.specifications = res.data.data.records[0].specifications
         // this.total = Number(res.data.data.total)
        })
      },
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      miniPathSuccess(res, file){
        this.accountForm.floorPath = res.data.ori_file[0];
      },
      impositionPathSuccess(res, file){
        this.accountForm.impositionPath = res.data.ori_file[0];
      },
      miniPanelPathPathSuccess(res, file){
        this.accountForm.panelPath = res.data.ori_file[0];
      },
      keepPathSuccess(res, file){
        this.accountForm.keepPath = res.data.ori_file[0];
      },
      thumbnailPathSuccess(res, file){
        this.accountForm.thumbnailPath = res.data.ori_file[0];
      },
      getProductCategory(){
        this.ProductFindDTO.access=localStorage.getItem("access")
        selectProductCategory(this.ProductFindDTO).then((res)=>{
        if(res.data.code===10000){
              this.category=res.data.data
            }
      })
      },
      handleEdit(row){
          this.dialogVisible=true
          this.accountForm=row
      },

      editAccount() {
      keepRemake(this.accountForm).then((res) => {
            console.log(res.status)
            if (res.data.msg === '操作成功') {
                this.$message({
                  type: 'success',
                  message: '修改成功!',
                }),
                this.getTableData()
                this.dialogVisible = false
              } else if (res.data.msg !== '操作成功') {
                this.$message({
                  type: 'info',
                  message: res.data.data
                })
              }
          })
        },
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      tohandleEdit(row){
        this.accountForm=row
        this.productAccountForm = Object.assign({},this.$options.data().productAccountForm);
        this.productAccountForm.access=localStorage.getItem("access")
        addToProduct(this.accountForm).then((res) => {
              this.productAccountForm=res.data.data
              console.log(res)
          })
        this.drawer = true
      },
      handleCurrentChange(val) {

        this.currentPage = val
        this.getTableData()
      },
      getTableData() {
        console.log(this.MiniFindDTO.materialType);
        keepSelectInfo(this.currentPage, this.pageSize, this.MiniFindDTO).then((res) => {
          this.conTract = res.data.data.records
          this.total = Number(res.data.data.total)
        })
      },
      submitForm(productAccountForm) {
        this.productAccountForm.access=localStorage.getItem("access")
        this.$refs[productAccountForm].validate((valid) => {
          if (valid) {
            addProduct(this.productAccountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',

              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      getCurrentTime() {
        //获取当前时间并打印
        var _this = this;
    let yy = new Date().getFullYear();
    let mm = new Date().getMonth()+1;
    let dd = new Date().getDate();
    let hh = new Date().getHours();
    let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
    let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
    _this.gettime = yy+'年'+mm+'月'+dd+'日'+hh+'点'+mf+'分'+ss+'秒';
    console.log(_this.gettime)
    return _this.gettime;
    },
      handleDelete(row) {
        if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          keepBatchDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    handleBathDelete(){
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          batchDelete(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    handleBathOrderProduction(){
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
      this.$confirm('您确定要下单制作吗？\n\n请确认！！！！！', '制作确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          orderProduction(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '制作成功!',
              }),
              this.getTableData()

            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消制作'
          })
        })
    },
    find(data){
      this.MiniFindDTO.materialType=data
      this.getTableData()
    },

      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },

      handleSelectionChange(val) {
        this.DeleteDTO=val
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.MiniFindDTO.startTime = e[0]
          this.MiniFindDTO.endTime = e[1]
        } else if (!e) {
          this.MiniFindDTO.startTime = ''
          this.MiniFindDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error('上传缩略图图片只能是 JPG/PNG/JPEG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传缩略图大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
        beforeAvatarUpload1(file) {
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过 20MB!');
        }
        return  isLt20M;
      },
      submit() {
      if(this.multipleSelection.length==0){
            this.$message({
              type: "error",
              message: "sorry,你还没有勾选任何文件呢!"
            });
            return;
          }
     let  materialType=this.multipleSelection[0].materialType;
     let productType=this.multipleSelection[0].productType;
    let fileType=this.multipleSelection[0].fileType;
          this.$message({
                type: 'success',
                message: '正在死命下载中,请稍等!!!!',
              }),

      fetch("api/serviceCenter/keep/downLoad", {
      body: JSON.stringify(this.multipleSelection),
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(res => {
      res.blob().then(blob => {
        // 转化为blobURL后再通过a标签下载
        console.log(window.URL.createObjectURL(blob))
        const blobUrl = window.URL.createObjectURL(blob);
        const a = window.document.createElement('a');
        let time= this.getCurrentTime();
        a.href = blobUrl;
        a.download =materialType+' '+productType+fileType+' '+time+'.zip';
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        this.getTableData()
      });
    });
    }
  }
}
  </script>

  <style lang="scss" scoped>
  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 20px;
  }
  .body {
    overflow: auto;
    padding-bottom: 50px;
  }

  .pagination {
    margin-top: 10px;
    margin-right: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .el-pagination ::v-deep.el-pagination__total {
    line-height: 36px;
  }
  </style>
